export default [
  {
    id: 1,
    name: 'Fruits et légumes',
    min: 5,
    period: 'day',
    cumulative: true
  },
  {
    id: 2,
    name: 'Viande rouge',
    max: 2,
    period: 'week',
    cumulative: false
  },
  {
    id: 3,
    name: 'Charcuterie',
    max: 1,
    period: 'week',
    cumulative: false
  },
  {
    id: 4,
    name: 'Viande blanche',
    max: 1,
    period: 'day',
    cumulative: false
  },
  {
    id: 5,
    name: 'Féculents et produits céréaliers',
    max: 2,
    period: 'day',
    cumulative: true
  },
  {
    id: 6,
    name: 'Poisson gras',
    max: 1,
    period: 'week',
    cumulative: false
  },
  {
    id: 7,
    name: 'Poisson maigre',
    max: 1,
    period: 'week',
    cumulative: false
  },
  {
    id: 8,
    name: 'Œuf',
    max: 1,
    period: 'day',
    cumulative: false
  },
  {
    id: 9,
    name: 'Produits laitiers',
    max: 3,
    period: 'day',
    cumulative: true
  },
  {
    id: 10,
    name: 'Légumineuses',
    min: 2,
    period: 'week',
    cumulative: true
  }
];
